import React, { Fragment } from "react";
import { motion } from "framer-motion";
import Header from "../../components/header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";

const Aldaa404 = ({ isDark, onToggleDark }) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };
  return (
    <Fragment>
      <motion.div
        intial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <Header isDark={isDark} hclass={"header--styleFour"} />
        <main className="main">
          <PageTitle pageTitle={"Алдаа 404"} pagesub={"404"} scdown />
          <div className="container not-found-content">
            <div className="row justify-content-center">
              <div className="col-lg-12">
                <div className="contant-wrapper text-center">
                  <div className="error-page__text">
                    <h1>404</h1>
                  </div>
                  <div className="error-page__content mb-50">
                    <h3>Уучлаарай! Энэ хуудас олдсонгүй!</h3>
                    <div className="error-page-button"></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="header__button">
              <a
                onClick={ClickHandler}
                className="btn btn--styleOne btn--primary it-btn"
                href="/"
              >
                <span className="btn__text">Нүүр хуудас</span>
                {/* <i className="fa-solid fa-heart btn__icon"></i> */}
                <span className="it-btn__inner">
                  <span className="it-btn__blobs">
                    <span className="it-btn__blob"></span>
                    <span className="it-btn__blob"></span>
                    <span className="it-btn__blob"></span>
                    <span className="it-btn__blob"></span>
                  </span>
                </span>
                <svg
                  className="it-btn__animation"
                  xmlns="http://www.w3.org/2000/svg"
                  version="1.1"
                >
                  <defs>
                    <filter>
                      <feGaussianBlur
                        in="SourceGraphic"
                        result="blur"
                        stdDeviation="10"
                      ></feGaussianBlur>
                      <feColorMatrix
                        in="blur"
                        mode="matrix"
                        values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 21 -7"
                        result="goo"
                      ></feColorMatrix>
                      <feBlend
                        in2="goo"
                        in="SourceGraphic"
                        result="mix"
                      ></feBlend>
                    </filter>
                  </defs>
                </svg>
              </a>
            </div>
          </div>
        </main>
        <Footer isDark={isDark} onToggleDark={onToggleDark} />
        <Scrollbar />
      </motion.div>
    </Fragment>
  );
};

export default Aldaa404;
